export const ERR_LOG = 'school/school-detail/manager/ERR_LOG';
export const ERR_LOG_BAK = 'school/school-detail/manager/ERR_LOG_BAK';



// WEBPACK FOOTER //
// ./src/store/modules/school/school-detail/activity/types.js